module.exports = __webpack_public_path__ + "img/portrait_placeholder.4788048f.png";